import React from "react";
import {Dialog} from "@material-ui/core";
import {Button} from "../../Button";
import {strings} from "../../../strings/strings";


interface INoDataByPhoneNumberDialogProps {
    isOpen: boolean;
    onSearch: () => void;
    onManual: () => void;
    phoneNumber: string;
}

export const NoDataByPhoneNumberDialog = (props: INoDataByPhoneNumberDialogProps) => {
    const {isOpen, phoneNumber, onSearch, onManual} = props;

    return (
        <Dialog open={isOpen} disableBackdropClick={true}>
            <div className={"dialog"}>
                <div className="dialog__content">
                    <span className={"dialog__message"}>{strings.noDataByPhoneDlg.text1}<span>{phoneNumber}</span>{strings.noDataByPhoneDlg.text2}</span>
                    <span className={"dialog__message"}>{strings.noDataByPhoneDlg.text3}</span>
                    <Button label={strings.toolbarSearch}
                            onClickListener={onSearch}/>

                    <Button variant={"notSelected"} label={strings.toolbarManual}
                            onClickListener={onManual}/>

                </div>
            </div>
        </Dialog>
    )

}